"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTML5Video = void 0;
var player_base_1 = require("@24i/player-base");
var player_utils_1 = require("@24i/player-utils");
var player_plugin_ads_1 = require("@24i/player-plugin-ads");
var player_ima_ads_1 = require("@24i/player-ima-ads");
var player_plugin_thumbnails_1 = require("@24i/player-plugin-thumbnails");
var lodash_throttle_1 = __importDefault(require("lodash.throttle"));
var support_1 = require("../support");
var helpers_1 = require("../helpers");
var Logger_1 = require("../Logger");
var player_plugin_chapters_1 = require("@24i/player-plugin-chapters");
var player_plugin_ssai_1 = require("@24i/player-plugin-ssai");
var player_plugin_googledai_1 = require("@24i/player-plugin-googledai");
var Metrics_1 = require("../Metrics");
var playerVersion = require('../../package.json').version;
var DEFAULT_TIMEUPDATE_THROTTLE = 300;
var SNAP_TO_SEGMENT_THRESHOLD = 5;
var PLAYBACK_RATES = [0.5, 0.75, 1.0, 1.25, 1.5, 2];
var HTML5Video = (function (_super) {
    __extends(HTML5Video, _super);
    function HTML5Video(config, parentElement, fullscreenContainer, logger) {
        if (logger === void 0) { logger = Logger_1.Logger; }
        var _this = _super.call(this) || this;
        _this.supportedFormats = HTML5Video.SupportedFormats;
        _this.textTrackElements = [];
        _this.adsManager = new player_plugin_ads_1.CombinedAdsManager();
        _this.chaptersManager = new player_plugin_chapters_1.CombinedChapters();
        _this.extraThumbnails = new player_plugin_thumbnails_1.CombinedThumbnails();
        _this.liveEdgeDelay = 0;
        _this.hasLoaded = false;
        _this.hasCanPlayReceived = false;
        _this.hasCanPlayTriggered = false;
        _this.hasStartPositionApplied = false;
        _this.playbackBlocked = false;
        _this.activeSeek = null;
        _this.seekingLevel = 0;
        _this.previousTime = 0;
        _this.metricsInternal = new Metrics_1.Metrics();
        _this.initializationConfig = config;
        _this.parentElement = parentElement;
        _this.fullscreenContainer = fullscreenContainer;
        _this.logger = logger;
        _this.mediaElement = _this.createVideoElement();
        _this.ttmlRenderingContainer = _this.createTTMLRenderingContainer();
        _this.adContainer = _this.createAdContainer();
        _this.extraThumbnails.register(new player_plugin_thumbnails_1.BackstageThumbnails());
        _this.extraThumbnails.register(new player_plugin_thumbnails_1.VttThumbnails());
        _this.chaptersManager.register(new player_plugin_chapters_1.TimelineChapters(_this));
        return _this;
    }
    Object.defineProperty(HTML5Video.prototype, "metrics", {
        get: function () {
            return this.metricsInternal.snapshot();
        },
        enumerable: false,
        configurable: true
    });
    HTML5Video.prototype.getPlayerName = function () {
        return HTML5Video.playerName;
    };
    HTML5Video.prototype.getVersion = function () {
        return HTML5Video.version;
    };
    HTML5Video.prototype.initializePlayer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, _super.prototype.initializePlayer.call(this)];
                    case 1:
                        _a.sent();
                        this.metricsInternal.attach(this);
                        if (!this.mediaElement) {
                            this.mediaElement = this.createVideoElement();
                            this.ttmlRenderingContainer = this.createTTMLRenderingContainer();
                            this.adContainer = this.createAdContainer();
                        }
                        this.parentElement.appendChild(this.mediaElement);
                        this.parentElement.appendChild(this.ttmlRenderingContainer);
                        this.parentElement.appendChild(this.adContainer);
                        if (this.muted) {
                            this.triggerEvent('mutedchanged', {
                                muted: true,
                            });
                        }
                        this.adsManager.register(new player_plugin_ssai_1.TimelineSsaiManager(this));
                        this.adsManager.register(new player_plugin_ssai_1.MediaTailorSsaiManager(this));
                        this.adsManager.register(new player_ima_ads_1.ImaAdsManager(this.mediaElement, this.parentElement, this));
                        this.adsManager.register(new player_plugin_googledai_1.GoogleDaiManager(this.mediaElement, this.adContainer, this));
                        this.listeners = this.createEventListeners();
                        this.bindEventListeners();
                        this.state = player_base_1.PlayerStates.START;
                        if (!this.source) return [3, 5];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, this.load()];
                    case 3:
                        _a.sent();
                        return [3, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.onError(error_1);
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    HTML5Video.prototype.createVideoElement = function () {
        var videoElement = document.createElement('video');
        videoElement.className = 'player';
        videoElement.style.display = 'block';
        videoElement.style.width = '100%';
        videoElement.style.height = '100%';
        videoElement.style.margin = 'auto';
        videoElement.crossOrigin = 'anonymous';
        videoElement.playsInline = true;
        videoElement.setAttribute('webkit-playsinline', 'true');
        return videoElement;
    };
    HTML5Video.prototype.createTTMLRenderingContainer = function () {
        var ttmlRenderingContainer = document.createElement('div');
        ttmlRenderingContainer.style.display = 'block';
        ttmlRenderingContainer.style.width = '100%';
        ttmlRenderingContainer.style.height = '100%';
        ttmlRenderingContainer.style.margin = 'auto';
        ttmlRenderingContainer.style.pointerEvents = 'none';
        return ttmlRenderingContainer;
    };
    HTML5Video.prototype.createAdContainer = function () {
        var adContainer = document.createElement('div');
        adContainer.className = 'player-embedded-ui';
        adContainer.style.position = 'absolute';
        adContainer.style.top = '0';
        adContainer.style.left = '0';
        adContainer.style.right = '0';
        adContainer.style.bottom = '0';
        return adContainer;
    };
    HTML5Video.prototype.createSourceElement = function (source) {
        var url = source.url, mimeType = source.mimeType;
        if (!mimeType) {
            this.logger.warn('Trying to play stream without specifing its mimeType');
        }
        var sourceElement = document.createElement('source');
        sourceElement.setAttribute('src', url);
        sourceElement.setAttribute('type', mimeType);
        sourceElement.addEventListener('error', this.onSourceError);
        this.sourceElement = sourceElement;
        return sourceElement;
    };
    HTML5Video.prototype.createTextTrackElement = function (source) {
        var url = source.url, language = source.language, kind = source.kind, id = source.id;
        var trackElement = document.createElement('track');
        trackElement.setAttribute('src', url);
        trackElement.setAttribute('kind', kind);
        trackElement.setAttribute('srclang', language);
        if (id) {
            trackElement.setAttribute('label', id);
            trackElement.setAttribute('id', id);
        }
        this.textTrackElements.push(trackElement);
        return trackElement;
    };
    HTML5Video.prototype.configureAbrStrategy = function () {
    };
    HTML5Video.prototype.configureDrm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var DRMProviderConstructor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        DRMProviderConstructor = this.source.drm.provider;
                        if (!(DRMProviderConstructor &&
                            typeof DRMProviderConstructor !== 'string' &&
                            DRMProviderConstructor.prototype instanceof player_base_1.DRMProvider)) return [3, 3];
                        this.drmProvider = new DRMProviderConstructor(this);
                        return [4, _super.prototype.setDrmProtection.call(this, this.source.drm)];
                    case 1:
                        _a.sent();
                        return [4, this.drmProvider.setDrmProtection(this.source.drm)];
                    case 2:
                        _a.sent();
                        return [3, 5];
                    case 3: return [4, this.setDrmProtection(this.source.drm)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2];
                }
            });
        });
    };
    HTML5Video.prototype.destroy = function () {
        this.unload();
        this.metricsInternal.detach();
        if (!this.parentElement)
            return;
        if (this.mediaElement && this.mediaElement.parentElement) {
            this.unbindEventListeners();
            this.parentElement.removeChild(this.mediaElement);
            this.mediaElement = null;
        }
        if (this.ttmlRenderingContainer &&
            this.ttmlRenderingContainer.parentElement)
            this.parentElement.removeChild(this.ttmlRenderingContainer);
        this.ttmlRenderingContainer = null;
        if (this.adContainer && this.adContainer.parentElement)
            this.parentElement.removeChild(this.adContainer);
        this.adContainer = null;
    };
    HTML5Video.prototype.createEventListeners = function () {
        var _this = this;
        var listeners = {};
        listeners.abort = function () {
            _this.triggerEvent('abort');
        };
        listeners.canplay = function () {
            _this.hasCanPlayReceived = true;
            if (_this.duration > 0) {
                _this.hasCanPlayTriggered = true;
                _this.onCanPlay();
            }
        };
        listeners.canplaythrough = function () {
            _this.triggerEvent('canplaythrough');
        };
        listeners.durationchange = function () {
            _this.triggerEvent('durationchange', {
                duration: _this.duration,
            });
            if (_this.hasCanPlayReceived &&
                !_this.hasCanPlayTriggered &&
                _this.duration > 0) {
                _this.hasCanPlayTriggered = true;
                _this.onCanPlay();
            }
        };
        listeners.emptied = function () {
            _this.triggerEvent('emptied');
        };
        listeners.encrypted = function () {
            _this.triggerEvent('encrypted');
        };
        listeners.ended = function () {
            _this.state = player_base_1.PlayerStates.END;
            _this.triggerEvent('ended');
        };
        listeners.error = function () {
            _this.onError();
        };
        listeners.loadeddata = function () {
            _this.state = player_base_1.PlayerStates.LOAD;
            _this.triggerEvent('loadeddata');
        };
        listeners.loadedmetadata = function () {
            _this.hasLoadedMetadata = true;
            _this.triggerEvent('loadedmetadata');
        };
        listeners.loadstart = function () {
            _this.triggerEvent('loadstart');
        };
        listeners.pause = function () {
            _this.state = player_base_1.PlayerStates.PAUSE;
            _this.triggerEvent('pause');
        };
        listeners.play = function () {
            _this.state = player_base_1.PlayerStates.PLAY;
            _this.triggerEvent('play');
        };
        listeners.playing = function () {
            _this.triggerEvent('playing');
        };
        listeners.progress = function () {
            _this.triggerEvent('progress');
        };
        listeners.ratechange = function () {
            _this.triggerEvent('ratechange', {
                playbackRate: _this.playbackRate,
            });
        };
        listeners.seeked = function () {
            _this.state = player_base_1.PlayerStates.SEEKED;
            _this.triggerSeeked();
        };
        listeners.seeking = function () {
            _this.state = player_base_1.PlayerStates.SEEKING;
            _this.triggerSeeking({}, true);
        };
        listeners.stalled = function () {
            _this.triggerEvent('stalled');
        };
        listeners.suspend = function () {
            _this.triggerEvent('suspend');
        };
        var throttledTimeUpdate = lodash_throttle_1.default(function () {
            _this.previousTime = _this.currentTime;
            _this.triggerEvent('timeupdate', {
                currentTime: _this.currentTime,
            });
            _this.maybeDoInitialSeek();
        }, DEFAULT_TIMEUPDATE_THROTTLE);
        listeners.timeupdate = throttledTimeUpdate;
        listeners.volumechange = function () {
            _this.triggerEvent('volumechange', {
                volume: _this.volume,
            });
        };
        listeners.waiting = function () {
            _this.triggerEvent('waiting');
        };
        return listeners;
    };
    HTML5Video.prototype.bindEventListeners = function () {
        var _this = this;
        if (!this.mediaElement || !this.mediaElement.addEventListener)
            return;
        Object.keys(this.listeners).forEach(function (listenerName) {
            _this.mediaElement.addEventListener(listenerName, _this.listeners[listenerName]);
        });
        if (this.fullscreenContainer &&
            this.fullscreenContainer.addEventListener) {
            this.fullscreenContainer.addEventListener('fullscreenchange', function () {
                var isFullscreen = _this.fullscreen;
                _this.triggerEvent('fullscreenchanged', {
                    isFullscreen: isFullscreen,
                });
            });
        }
    };
    HTML5Video.prototype.unbindEventListeners = function () {
        var _this = this;
        var videoElement = this.mediaElement;
        if (videoElement && this.listeners) {
            Object.keys(this.listeners).forEach(function (listenerName) {
                videoElement.removeEventListener(listenerName, _this.listeners[listenerName]);
            });
        }
    };
    Object.defineProperty(HTML5Video.prototype, "preloadMode", {
        get: function () {
            var _a;
            return (_a = this.mediaElement) === null || _a === void 0 ? void 0 : _a.preload;
        },
        set: function (preloadMode) {
            if (this.mediaElement) {
                this.mediaElement.preload = preloadMode || 'auto';
            }
        },
        enumerable: false,
        configurable: true
    });
    HTML5Video.prototype.addTextTrack = function (textTrack) {
        if (!this.mediaElement)
            return;
        this.mediaElement.appendChild(this.createTextTrackElement(textTrack));
    };
    Object.defineProperty(HTML5Video.prototype, "source", {
        get: function () {
            return this.sourceConfigurationObject;
        },
        set: function (source) {
            this.sourceConfigurationObject = source;
            if (this.mediaElement) {
                var poster = helpers_1.choosePoster(source.posters, player_base_1.SourcePosterUsage.PLACEHOLDER);
                this.mediaElement.poster = poster ? poster.url : '';
            }
        },
        enumerable: false,
        configurable: true
    });
    HTML5Video.prototype.getThumbnails = function (timesInMs) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.extraThumbnails.isReady()) {
                    return [2, this.extraThumbnails.getThumbnails(timesInMs)];
                }
                return [2, Array(timesInMs.length)];
            });
        });
    };
    Object.defineProperty(HTML5Video.prototype, "timeline", {
        get: function () {
            return player_plugin_ads_1.mergeTimeline(this.chaptersManager.timeline, this.adsManager.timelineEvents);
        },
        enumerable: false,
        configurable: true
    });
    HTML5Video.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.allowPlay)
                            return [2];
                        if (this.hasLoaded) {
                            this.unload();
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, this.preLoadChecks()];
                    case 2:
                        _b.sent();
                        return [3, 4];
                    case 3:
                        error_2 = _b.sent();
                        this.logger.warn('preloadChecks failed');
                        throw error_2;
                    case 4:
                        if (!this.mediaElement) {
                            throw new Error('no mediaElement is present');
                        }
                        this.metricsInternal.load();
                        if (this.abrStrategy) {
                            this.configureAbrStrategy();
                        }
                        _a = this;
                        return [4, this.adsManager.load(this.source)];
                    case 5:
                        _a.source = _b.sent();
                        if (this.source.textTracks) {
                            this.source.textTracks.forEach(function (textTrack) {
                                _this.addTextTrack(textTrack);
                            });
                        }
                        if (!this.source.drm) return [3, 7];
                        return [4, this.configureDrm()];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7:
                        this.state = player_base_1.PlayerStates.LOAD;
                        this.hasLoaded = true;
                        return [4, this.mediaLoad()];
                    case 8:
                        _b.sent();
                        return [4, this.extraThumbnails.load(this.source)];
                    case 9:
                        _b.sent();
                        return [4, this.chaptersManager.load(this.source)];
                    case 10:
                        _b.sent();
                        return [2];
                }
            });
        });
    };
    HTML5Video.prototype.setMetadata = function (metadata) {
        _super.prototype.setMetadata.call(this, metadata);
        this.adsManager.setMetadata(metadata);
        this.chaptersManager.setMetadata(metadata);
    };
    HTML5Video.prototype.mediaLoad = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.hasCanPlayReceived = false;
                this.hasCanPlayTriggered = false;
                this.hasStartPositionApplied = false;
                if (this.source) {
                    this.mediaElement.appendChild(this.createSourceElement(this.source));
                }
                if (this.sourceElement && this.listeners.error) {
                    this.sourceElement.onerror = this.listeners
                        .error;
                }
                this.mediaElement.load();
                return [2, Promise.resolve()];
            });
        });
    };
    HTML5Video.prototype.unload = function () {
        var _this = this;
        this.hasLoaded = false;
        this.pause();
        this.metricsInternal.unload();
        if (this.mediaElement &&
            this.sourceElement &&
            this.sourceElement.parentElement) {
            this.mediaElement.removeChild(this.sourceElement);
            this.mediaElement.removeAttribute('src');
            if (this.state !== player_base_1.PlayerStates.ERROR) {
                this.mediaElement.load();
            }
        }
        if (this.mediaElement && this.textTrackElements.length) {
            this.textTrackElements.forEach(function (textTrack) {
                _this.mediaElement.removeChild(textTrack);
            });
            this.textTrackElements = [];
        }
        this.adsManager.unload();
        this.hasCanPlayReceived = false;
        this.hasCanPlayTriggered = false;
        this.hasStartPositionApplied = false;
    };
    Object.defineProperty(HTML5Video.prototype, "fullscreen", {
        get: function () {
            return (!!document.fullscreenElement &&
                document.fullscreenElement === this.fullscreenContainer);
        },
        set: function (value) {
            if (!this.fullscreenContainer) {
                this.logger.warn('You need to provide "fullscreenContainer" to control fullscreen state.');
            }
            var noop = function () {
            };
            if (value) {
                var fullscreenContainer = this.fullscreenContainer;
                if (fullscreenContainer) {
                    var requestFullScreen = fullscreenContainer.requestFullscreen ||
                        fullscreenContainer.webkitRequestFullscreen ||
                        fullscreenContainer.msRequestFullscreen ||
                        noop;
                    requestFullScreen.call(fullscreenContainer);
                }
            }
            else if (document.fullscreenElement) {
                var anyDocument = document;
                var exitFullScreen = anyDocument.exitFullscreen ||
                    anyDocument.webkitExitFullscreen ||
                    anyDocument.msExitFullscreen ||
                    noop;
                exitFullScreen.call(anyDocument);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "playbackRates", {
        get: function () {
            return PLAYBACK_RATES;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "playbackRate", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.mediaElement) === null || _a === void 0 ? void 0 : _a.playbackRate) !== null && _b !== void 0 ? _b : 1.0;
        },
        set: function (value) {
            if (this.mediaElement)
                this.mediaElement.playbackRate = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "volume", {
        get: function () {
            var _a, _b;
            if (!this.mediaElement)
                return 1;
            if (this.adsManager.isPlayingClientSide)
                return this.adsManager.volume;
            return (_b = (_a = this.mediaElement) === null || _a === void 0 ? void 0 : _a.volume) !== null && _b !== void 0 ? _b : 1;
        },
        set: function (value) {
            if (!this.mediaElement)
                return;
            this.mediaElement.volume = value;
            this.adsManager.volume = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "muted", {
        get: function () {
            var _a;
            return ((_a = this.mediaElement) === null || _a === void 0 ? void 0 : _a.muted) || this.volume === 0;
        },
        set: function (muted) {
            if (!this.mediaElement)
                return;
            this.mediaElement.muted = muted;
            this.adsManager.muted = muted;
            this.triggerEvent('mutedchanged', {
                muted: muted,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "autoPlay", {
        get: function () {
            if (!this.mediaElement)
                return false;
            return this.mediaElement.autoplay;
        },
        set: function (autoPlay) {
            if (!this.mediaElement)
                return;
            if (autoPlay) {
                this.mediaElement.autoplay = this.allowPlay;
                if (this.mediaElement.paused && this.allowPlay) {
                    this.mediaElement.play().catch(function () {
                    });
                }
            }
            else {
                this.mediaElement.autoplay = false;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "paused", {
        get: function () {
            if (!this.mediaElement)
                return true;
            if (this.adsManager.isPlayingClientSide)
                return this.adsManager.paused;
            return this.mediaElement.paused;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "playing", {
        get: function () {
            return !this.paused;
        },
        enumerable: false,
        configurable: true
    });
    HTML5Video.prototype.pause = function () {
        if (this.adsManager.isPlayingClientSide) {
            this.adsManager.pause();
        }
        else if (this.mediaElement) {
            this.mediaElement.pause();
        }
    };
    HTML5Video.prototype.play = function () {
        var _this = this;
        if (!this.allowPlay)
            return;
        if (this.state === player_base_1.PlayerStates.START) {
            this.autoPlay = true;
            this.load()
                .then(function () {
                _this.mediaElement.play();
            })
                .catch(function (e) {
                _this.onError(e);
            });
        }
        else if (this.adsManager.isPlayingClientSide) {
            this.adsManager.play();
        }
        else if (this.mediaElement) {
            this.mediaElement.play();
        }
    };
    Object.defineProperty(HTML5Video.prototype, "live", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "ended", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.mediaElement) === null || _a === void 0 ? void 0 : _a.ended) !== null && _b !== void 0 ? _b : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "seeking", {
        get: function () {
            if (!this.mediaElement)
                return false;
            if (this.activeSeek)
                return true;
            return this.mediaElement.seeking;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "currentTime", {
        get: function () {
            if (!this.mediaElement)
                return 0;
            if (this.adsManager.isPlayingClientSide)
                return this.adsManager.currentTime;
            return player_utils_1.secondsToMilliseconds(this.mediaElement.currentTime) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "duration", {
        get: function () {
            if (!this.mediaElement)
                return 0;
            if (this.adsManager.isPlayingClientSide)
                return this.adsManager.duration;
            if (this.live)
                return Infinity;
            return player_utils_1.secondsToMilliseconds(this.mediaElement.duration) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "seekableRange", {
        get: function () {
            if (!this.mediaElement)
                return {
                    start: 0,
                    end: 0,
                };
            var seekable = this.mediaElement.seekable;
            if (this.adsManager.isPlayingClientSide || seekable.length === 0)
                return {
                    start: this.currentTime,
                    end: this.currentTime,
                };
            var seekableStart = seekable.start(0);
            var seekableEnd = seekable.end(seekable.length - 1);
            return {
                start: this.applySeekingRestriction(player_utils_1.secondsToMilliseconds(seekableStart)),
                end: this.applySeekingRestriction(player_utils_1.secondsToMilliseconds(seekableEnd)),
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "timeshiftRange", {
        get: function () {
            if (!this.mediaElement || !this.live)
                return {
                    start: 0,
                    end: 0,
                };
            var seekable = this.mediaElement.seekable;
            if (this.adsManager.isPlayingClientSide || seekable.length === 0)
                return {
                    start: this.currentTime,
                    end: this.currentTime,
                };
            var seekableStart = seekable.start(0);
            var seekableEnd = seekable.end(seekable.length - 1);
            return {
                start: player_utils_1.secondsToMilliseconds(seekableStart),
                end: player_utils_1.secondsToMilliseconds(seekableEnd),
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "bufferedRanges", {
        get: function () {
            if (!this.mediaElement)
                return [];
            if (this.adsManager.isPlayingClientSide)
                return [];
            var bufferRanges = [];
            var buffered = this.mediaElement.buffered;
            if (buffered && buffered.length) {
                for (var i = 0; i < buffered.length; i++) {
                    bufferRanges.push({
                        start: player_utils_1.secondsToMilliseconds(buffered.start(i)),
                        end: player_utils_1.secondsToMilliseconds(buffered.end(i)),
                    });
                }
            }
            return bufferRanges;
        },
        enumerable: false,
        configurable: true
    });
    HTML5Video.prototype.getContentTime = function (streamTime) {
        return this.adsManager.getContentTime(streamTime);
    };
    HTML5Video.prototype.getStreamTime = function (time, seekType) {
        var _a, _b;
        if (seekType === void 0) { seekType = player_base_1.SeekType.CONTENT_TIME; }
        var _c = this, live = _c.live, timeshiftRange = _c.timeshiftRange;
        var finalTime = time;
        if (seekType === player_base_1.SeekType.CONTENT_TIME) {
            finalTime = this.adsManager.getMediaTime(time);
        }
        if (seekType === player_base_1.SeekType.TIMESHIFT && live) {
            finalTime = time + timeshiftRange.end;
        }
        if (seekType === player_base_1.SeekType.UTC) {
            if (live) {
                finalTime =
                    time - Date.now() + timeshiftRange.end + this.liveEdgeDelay;
            }
            else {
                var programStart = ((_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.programStart) || 0;
                finalTime = time - programStart;
            }
        }
        return finalTime;
    };
    HTML5Video.prototype.seek = function (seekToTime, seekType, seekOptions) {
        if (seekType === void 0) { seekType = player_base_1.SeekType.CURRENT_TIME; }
        if (seekOptions === void 0) { seekOptions = {}; }
        if (typeof seekToTime !== 'number' || Number.isNaN(seekToTime))
            return;
        var currentTime = this.currentTime;
        var activeSeek = {
            from: currentTime,
            time: seekToTime,
            type: seekType,
            options: seekOptions,
            currentTime: this.getStreamTime(seekToTime, seekType),
        };
        if (!Number.isFinite(activeSeek.currentTime))
            return;
        var applySeekFunctions = [
            this.applySeekStartLive,
            this.applySeekAllowPlay,
            this.applySeekClientAdvertisement,
            this.applySeekRestrictions,
            this.applySeekAdvertisement,
            this.applySeekWindow,
        ];
        for (var _i = 0, applySeekFunctions_1 = applySeekFunctions; _i < applySeekFunctions_1.length; _i++) {
            var applySeekFunction = applySeekFunctions_1[_i];
            var originalTime = activeSeek.currentTime;
            var applySeekResult = applySeekFunction.call(this, activeSeek, originalTime, seekOptions);
            var adjustedTime = applySeekResult.currentTime;
            activeSeek = __assign(__assign({}, activeSeek), applySeekResult);
            if (adjustedTime === null || adjustedTime === currentTime) {
                activeSeek.currentTime = currentTime;
            }
        }
        var finalTime = activeSeek.currentTime;
        this.triggerSeeking(activeSeek, false);
        if (finalTime === currentTime) {
            this.triggerSeeked();
        }
        else {
            this.mediaSeek(finalTime);
        }
    };
    HTML5Video.prototype.applySeekStartLive = function (activeSeek) {
        var _a;
        if (((_a = activeSeek.options) === null || _a === void 0 ? void 0 : _a.startupPosition) === true &&
            activeSeek.type === player_base_1.SeekType.TIMESHIFT) {
            if (this.live && activeSeek.time === 0) {
                if (!this.isOnLiveEdge()) {
                    this.logger.warn("Starting from non-default position " + this.currentTime + " / " + this.timeshiftRange.end);
                    return {};
                }
                return {
                    currentTime: activeSeek.from,
                };
            }
        }
        return {};
    };
    HTML5Video.prototype.applySeekAllowPlay = function (activeSeek) {
        if (this.allowPlay)
            return {};
        return {
            disablePlay: true,
            currentTime: activeSeek.from,
        };
    };
    HTML5Video.prototype.applySeekClientAdvertisement = function (activeSeek) {
        var currentAd = this.currentAd;
        if (!currentAd || currentAd.inStreamAdvertisement)
            return {};
        return {
            unskippableAdvertisement: true,
            currentTime: activeSeek.from,
        };
    };
    HTML5Video.prototype.applySeekRestrictions = function (activeSeek, resolvedTime) {
        var _a;
        var _b = this, currentTime = _b.currentTime, currentSeekingRestrictionKey = _b.currentSeekingRestrictionKey;
        var currentSeekingRestriction = this.resolveSeekingRestriction(currentSeekingRestrictionKey);
        var afterAdjustment = this.applySeekingRestriction(resolvedTime, (_a = activeSeek.from) !== null && _a !== void 0 ? _a : currentTime, currentSeekingRestriction);
        if (resolvedTime === afterAdjustment)
            return {};
        return {
            seekingRestricted: true,
            seekingRestrictionKey: currentSeekingRestrictionKey,
            seekingRestriction: currentSeekingRestriction,
            currentTime: afterAdjustment,
        };
    };
    HTML5Video.prototype.applySeekAdvertisement = function (activeSeek) {
        return this.adsManager.seek(activeSeek);
    };
    HTML5Video.prototype.applySeekWindow = function (activeSeek, resolvedTime) {
        var seekableRange = this.seekableRange;
        var start = seekableRange.start, end = seekableRange.end;
        var adjustedTime = Math.max(start, Math.min(end, resolvedTime));
        if (resolvedTime === adjustedTime)
            return {};
        return {
            currentTime: adjustedTime,
            clampedToWindow: true,
            seekableRange: seekableRange,
            originalTime: resolvedTime,
        };
    };
    HTML5Video.prototype.mediaSeek = function (resolvedTime) {
        this.mediaElement.currentTime = player_utils_1.millisecondsToSeconds(resolvedTime);
    };
    HTML5Video.prototype.triggerSeeking = function (seekChanges, isSeekConfirmation) {
        var _a, _b, _c, _d, _e, _f;
        var _g = this, activeSeek = _g.activeSeek, currentTime = _g.currentTime, previousTime = _g.previousTime, live = _g.live;
        var finalSeek = __assign(__assign(__assign({ time: currentTime, type: player_base_1.SeekType.CURRENT_TIME, currentTime: currentTime }, activeSeek), seekChanges), { from: (_c = (_b = (_a = this.activeSeek) === null || _a === void 0 ? void 0 : _a.from) !== null && _b !== void 0 ? _b : seekChanges === null || seekChanges === void 0 ? void 0 : seekChanges.from) !== null && _c !== void 0 ? _c : previousTime });
        if (!activeSeek && isSeekConfirmation) {
            this.logger.debug("Ad-hoc seeking: " + previousTime + "=>" + currentTime);
        }
        if (isSeekConfirmation) {
            this.seekingLevel += 1;
        }
        this.activeSeek = finalSeek;
        if (!activeSeek) {
            this.triggerEvent('seeking', {
                from: finalSeek.from,
                time: finalSeek.time,
                type: finalSeek.type,
            });
        }
        if (live &&
            finalSeek.clampedToWindow &&
            !((_d = finalSeek.options) === null || _d === void 0 ? void 0 : _d.startupPosition)) {
            this.triggerEvent('seekingoutofdvr', {
                time: (_e = finalSeek.originalTime) !== null && _e !== void 0 ? _e : finalSeek.currentTime,
                seekableRange: (_f = finalSeek.seekableRange) !== null && _f !== void 0 ? _f : this.timeshiftRange,
            });
        }
    };
    HTML5Video.prototype.triggerSeeked = function () {
        var _a, _b, _c;
        var _d = this, activeSeek = _d.activeSeek, currentTime = _d.currentTime, previousTime = _d.previousTime;
        var seeking = this.mediaElement.seeking;
        if (this.seekingLevel <= 1 || (this.seekingLevel > 1 && !seeking)) {
            this.seekingLevel = 0;
            this.activeSeek = null;
            var snappedToSegment = !!activeSeek &&
                Math.abs(activeSeek.currentTime - currentTime) >
                    SNAP_TO_SEGMENT_THRESHOLD;
            this.triggerEvent('seeked', __assign(__assign({ from: (_a = activeSeek === null || activeSeek === void 0 ? void 0 : activeSeek.from) !== null && _a !== void 0 ? _a : previousTime, time: (_b = activeSeek === null || activeSeek === void 0 ? void 0 : activeSeek.time) !== null && _b !== void 0 ? _b : currentTime, type: (_c = activeSeek === null || activeSeek === void 0 ? void 0 : activeSeek.type) !== null && _c !== void 0 ? _c : player_base_1.SeekType.CURRENT_TIME }, activeSeek), { currentTime: currentTime, snappedToSegment: snappedToSegment }));
        }
        else {
            this.seekingLevel = Math.max(this.seekingLevel - 1, 0);
        }
    };
    HTML5Video.prototype.getUTCTimestamp = function (value) {
        var _a, _b;
        if (value === void 0) { value = this.currentTime; }
        var _c = this, live = _c.live, timeshiftRange = _c.timeshiftRange, liveEdgeDelay = _c.liveEdgeDelay;
        var timeshiftEnd = timeshiftRange.end;
        var programStart = ((_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.programStart) || undefined;
        if (live) {
            return new Date(value - timeshiftEnd + Date.now() - liveEdgeDelay);
        }
        else if (programStart) {
            return new Date(programStart + value);
        }
        else {
            return null;
        }
    };
    HTML5Video.prototype.backward = function (value) {
        this.seek(this.currentTime - value);
    };
    HTML5Video.prototype.forward = function (value) {
        this.seek(this.currentTime + value);
    };
    Object.defineProperty(HTML5Video.prototype, "videoTrack", {
        get: function () {
            return this.wasVideoTrackSelected ? this.selectedVideoTrack : null;
        },
        set: function (videoTrack) {
            this.wasVideoTrackSelected = Boolean(videoTrack);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "selectedAudioTrack", {
        get: function () {
            return this.audioTracks.filter(function (audioTrack) {
                return audioTrack.selected;
            })[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "selectedTextTrack", {
        get: function () {
            var textTracks = this.mediaElement.textTracks;
            var activeTextTrack;
            for (var i = 0; i < textTracks.length; i++) {
                if (textTracks[i].mode === 'showing') {
                    activeTextTrack = {
                        id: textTracks[i].id,
                        language: textTracks[i].language,
                        selected: true,
                        default: false,
                        kind: textTracks[i].kind,
                        forced: false,
                        type: player_base_1.TrackType.Text,
                    };
                    break;
                }
            }
            return activeTextTrack;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "selectedVideoTrack", {
        get: function () {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "videoTracks", {
        get: function () {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "audioTracks", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    HTML5Video.prototype.getTextTracks = function () {
        var textTracks = this.mediaElement.textTracks;
        var tracks = [];
        tracks.push(this.getEmptyTextTrack(!this.wasTextTrackSelected));
        for (var i = 0; i < textTracks.length; i++) {
            var track = textTracks[i];
            if (track.kind === player_base_1.TrackKind.Captions ||
                track.kind === player_base_1.TrackKind.Subtitles) {
                tracks.push({
                    id: track.id,
                    language: track.language,
                    selected: track.mode !== 'disabled',
                    default: false,
                    kind: track.kind,
                    forced: false,
                    label: track.label,
                    type: player_base_1.TrackType.Text,
                });
            }
        }
        return tracks;
    };
    Object.defineProperty(HTML5Video.prototype, "textTracks", {
        get: function () {
            return this.getTextTracks();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "audioTrack", {
        get: function () {
            return this.wasAudioTrackSelected ? this.selectedAudioTrack : null;
        },
        set: function (audioTrack) {
            this.wasAudioTrackSelected = Boolean(audioTrack);
        },
        enumerable: false,
        configurable: true
    });
    HTML5Video.prototype.setTextTrack = function (textTrack) {
        if (!this.mediaElement)
            return;
        var shouldTextTracksBeDisplayed = textTrack && textTrack.id !== player_base_1.EMPTY_TRACK_ID;
        this.wasTextTrackSelected =
            Boolean(textTrack) && shouldTextTracksBeDisplayed;
        var textTracks = this.mediaElement.textTracks;
        for (var i = 0; i < textTracks.length; i++) {
            if (textTracks[i].id === textTrack.id) {
                textTracks[i].mode = 'showing';
            }
            else {
                textTracks[i].mode = 'disabled';
            }
        }
        this.triggerEvent('texttrackchanged', {
            track: this.selectedTextTrack,
        });
    };
    Object.defineProperty(HTML5Video.prototype, "textTrack", {
        get: function () {
            return this.wasTextTrackSelected ? this.selectedTextTrack : null;
        },
        set: function (textTrack) {
            this.setTextTrack(textTrack);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "trackRestrictions", {
        get: function () {
            return this.abrTrackRestrictions;
        },
        set: function (restrictions) {
            this.abrTrackRestrictions = restrictions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "seekingRestrictions", {
        get: function () {
            return this.seekingRestrictionsInternal;
        },
        set: function (playbackRestrictions) {
            this.seekingRestrictionsInternal = playbackRestrictions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "performanceTweaks", {
        get: function () {
            return this.performanceTweaksInternal;
        },
        set: function (performanceTweaks) {
            this.performanceTweaksInternal = performanceTweaks;
            this.initializationConfig.performanceTweaks = performanceTweaks;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "qualityConfiguraion", {
        get: function () {
            return this.initializationConfig.quality;
        },
        set: function (config) {
            this.initializationConfig.quality = config;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "allowPlay", {
        get: function () {
            return !this.playbackBlocked;
        },
        set: function (allowPlay) {
            this.playbackBlocked = !allowPlay;
            if (!allowPlay) {
                this.autoPlay = false;
                this.pause();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "adBreaks", {
        get: function () {
            return this.adsManager.adBreaks;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "currentAdBreak", {
        get: function () {
            return this.adsManager.currentAdBreak;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTML5Video.prototype, "currentAd", {
        get: function () {
            return this.adsManager.currentAd;
        },
        enumerable: false,
        configurable: true
    });
    HTML5Video.prototype.skipAd = function () {
        this.adsManager.skipAd();
    };
    Object.defineProperty(HTML5Video.prototype, "canSkipAd", {
        get: function () {
            return this.adsManager.canSkipAd;
        },
        enumerable: false,
        configurable: true
    });
    HTML5Video.prototype.getMediaInfo = function () {
        return {
            playerVersion: HTML5Video.playerName + " v." + this.getVersion(),
            currentTime: this.currentTime,
            duration: this.duration,
        };
    };
    HTML5Video.prototype.isReady = function () {
        return false;
    };
    HTML5Video.prototype.isSetup = function () {
        return false;
    };
    HTML5Video.prototype.isStalled = function () {
        return false;
    };
    HTML5Video.prototype.castToDevice = function () { };
    HTML5Video.prototype.setAbrStrategy = function (abrStrategy) {
        if (!this.mediaElement)
            return;
        this.abrStrategy = abrStrategy;
    };
    HTML5Video.prototype.onCanPlay = function () {
        this.maybeDoInitialSeek();
        this.triggerEvent('canplay');
    };
    HTML5Video.prototype.maybeDoInitialSeek = function () {
        if (this.hasStartPositionApplied)
            return;
        if (!this.hasCanPlayReceived && !this.duration)
            return;
        if (this.adsManager.shouldPostponeInitialSeek())
            return;
        this.hasStartPositionApplied = true;
        this.seek(this.startPosition, this.startPositionType, {
            startupPosition: true,
        });
    };
    HTML5Video.prototype.onError = function (error) {
        var _a;
        if (error === undefined) {
            var mediaError = (_a = this.mediaElement) === null || _a === void 0 ? void 0 : _a.error;
            if (mediaError) {
                _super.prototype.onError.call(this, new player_base_1.PlayerError({
                    code: player_base_1.ErrorCodes.PLAYER_FAILURE,
                    engine: HTML5Video.playerName,
                    engineVersion: HTML5Video.version,
                    nativeCode: mediaError.code.toString(),
                    message: mediaError.message,
                    source: this.sourceConfigurationObject,
                }));
            }
            else {
                console.warn('[Player HTML5 Video] Ignoring unexpected error event');
            }
        }
        else {
            _super.prototype.onError.call(this, error);
        }
    };
    HTML5Video.prototype.onSourceError = function () {
        var _a;
        if (((_a = this.mediaElement) === null || _a === void 0 ? void 0 : _a.networkState) ===
            HTMLMediaElement.NETWORK_NO_SOURCE) {
            _super.prototype.onError.call(this, new player_base_1.PlayerError({
                code: navigator.onLine === false
                    ? player_base_1.ErrorCodes.NETWORK_FAILURE
                    : player_base_1.ErrorCodes.PLAYER_SOURCE_UNAVAILABLE,
                engine: HTML5Video.playerName,
                engineVersion: HTML5Video.version,
                nativeCode: MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED.toString(),
                message: 'No source',
                source: this.sourceConfigurationObject,
            }));
        }
    };
    HTML5Video.playerName = 'html5';
    HTML5Video.version = playerVersion;
    HTML5Video.SupportedFormats = new support_1.Html5SupportedFormats();
    return HTML5Video;
}(player_base_1.PlayerBase));
exports.HTML5Video = HTML5Video;
//# sourceMappingURL=index.js.map